export class Model {
    constructor(props = {}) {
        this.bootstrap(props);
        for (const prop in props) {
            if (this[`cast_${prop}`]) {
                this[prop] = this[`cast_${prop}`](props[prop], props);
            } else {
                if (prop.startsWith('_')) {
                    Object.defineProperty(
                        this, prop.slice(1),
                        {
                            enumerable: false,
                            value: props[prop],
                            writable: true
                        });
                } else {
                    this[prop] = props[prop];
                }
            }
        }
    }

    bootstrap(props) {

    }

    get(prop, defaultValue = null) {
        try {
            let path = this;

            prop.split('.').forEach((part) => {
                path = path[part];
            });

            return typeof path === 'undefined' ? defaultValue : path;
        } catch (ex) {
            return defaultValue;
        }
    }

    set(prop, value) {
        let path = this;
        let parts = prop.split('.');
        parts.forEach((part, index) => {
            if (!path[part]) {
                path[part] = {};
            }

            if (index == (parts.length - 1)) {
                path[part] = value;
            } else {
                path = path[part];
            }
        });

        return path;
    }
}
